import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

const RadioInput = ({
	field,
	value,
	handleChange,
	fieldName,
	fieldId,
	sectionId,
	typeCode,
	isRequired,
	disabled,
}) => {
	const handleRadioChange = selectedValue => {
		handleChange({
			sectionId,
			fieldName,
			fieldId,
			typeCode,
			value: selectedValue,
			isRequired,
		});
	};

	return (
		<div className="radio-group">
			{field.params.map(option => (
				<label key={option.value} className="radio-label">
					<input
						type="radio"
						name={fieldName}
						value={option.value}
						checked={value === option.value}
						onChange={() => handleRadioChange(option.value)}
						disabled={disabled || option.isDisabled}
					/>
					<span className="radio-text">
						<FormattedMessage id={option.key || option.label} />
					</span>
				</label>
			))}
		</div>
	);
};

RadioInput.propTypes = {
	field: PropTypes.shape({
		params: PropTypes.arrayOf(
			PropTypes.shape({
				value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
					.isRequired,
				key: PropTypes.string,
				label: PropTypes.string,
				isDisabled: PropTypes.bool,
			}),
		).isRequired,
	}).isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	handleChange: PropTypes.func.isRequired,
	fieldName: PropTypes.string.isRequired,
	fieldId: PropTypes.string.isRequired,
	sectionId: PropTypes.string.isRequired,
	typeCode: PropTypes.string.isRequired,
	isRequired: PropTypes.bool,
	disabled: PropTypes.bool,
};

RadioInput.defaultProps = {
	value: "",
	isRequired: false,
	disabled: false,
};

export default RadioInput;
